type SwitchRendererProps = {
  type: string;
  components: Record<string, React.ReactNode>;
};

export const SwitchRenderer: React.FC<SwitchRendererProps> = ({
  type,
  components,
}) => {
  return <>{components[type] || components["default"] || null}</>;
};
